/**
 * AUTO-GENERATED by scripts/generate-cvent-plan.mjs — DO NOT EDIT BY HAND.
 *
 * Source of truth: src/analytics/cvent/actions/*.json.
 * Regenerate with: pnpm attendee-activities:generate-plan
 */
import { Action, type AttendeeActivitiesActionProps } from '@cvent/analytics/Action';

/**
 * Props for the "reaction added" Attendee Activities fact.
 *
 * Extends `AttendeeActivitiesActionProps`, which requires `objectId`. For this
 * fact the `objectId` mirrors `sessionId`.
 */
export interface ReactionAddedProps extends AttendeeActivitiesActionProps {
  /** Identifier of the Goldcast session the reaction was sent in. */
  sessionId: string;

  /** Cvent reaction enum index. */
  reactionType?: number;

  /** Cvent reaction name, or the Goldcast id when unmapped. */
  reactionName: string;

  /** Whole seconds into the stream when the reaction was sent. */
  streamOffsetSeconds?: number;
}

/**
 * `@cvent/analytics` Action model for the "reaction added" fact.
 *
 * The `id` is the Attendee Activities `activity_type`. Routing is not set per action — the
 * singleton's `defaultDestinations` (`CVENT_ANALYTICS_DESTINATIONS`) routes
 * every fact, matching `../actions/reaction_added.json`.
 *
 * @description Tracks when an attendee sends a floating-emoji reaction during a Goldcast session, publishing to the Cvent Attendee Activities pipeline to build a unified record of attendee engagement.
 * @trigger Fired once a floating-emoji reaction has been successfully sent during a live or simulive session.
 */
export default class ReactionAdded extends Action<ReactionAddedProps> {
  id = 'session.reactionAdded';
}
